import { useState, useEffect, useRef } from 'react';
import Item from '../../components/Item';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import Paths from '../../constants/paths';
import getFormInput from './getFormInput';
import translations from '../../translations/de';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { ALL_WEBHOOK_EVENT_TYPES } from '../../configs/webhooks';

const NewWebhook = ({ store }) => {
    const history = useHistory();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [createdSecret, setCreatedSecret] = useState(null);
    const modalRef = useRef(null);

    useEffect(() => {
        !store.dataLoaded && store.setDataLoaded();
    }, [store]);

    return (
        <>
            <Item
                links={[{ path: Paths.WEBHOOKS, name: translations.webhooks }]}
                name={`${translations.webhook} ${translations.create}`}
                itemModel={{
                    name: '',
                    url: '',
                    event_types: [...ALL_WEBHOOK_EVENT_TYPES],
                }}
                edit={true}
                onSubmit={(event) => {
                    setLoading(true);
                    error && setError(null);
                    store
                        .createSubscription({ ...event })
                        .then((secret) => {
                            setLoading(false);
                            setCreatedSecret(secret);
                        })
                        .catch((err) => {
                            setError(err);
                            setLoading(false);
                        });
                }}
                onCancel={() => history.goBack()}
                error={error}
                loading={loading}
                determineInputType={({ control, name, register, error, disabled, index }) =>
                    getFormInput({ name, register, control, error, disabled, index })
                }
            />

            {createdSecret && (
                <Modal
                    title={translations.webhook_secret_title}
                    ref={modalRef}
                    onClose={() => {
                        setCreatedSecret(null);
                        history.push(Paths.WEBHOOKS);
                    }}
                    maxWidth="600px"
                >
                    <p style={{ color: '#333', marginBottom: '10px' }}>
                        {translations.webhook_secret_warning}
                    </p>
                    <pre
                        style={{
                            background: '#f5f5f5',
                            color: '#000',
                            padding: '10px',
                            border: '1px solid #ddd',
                            wordBreak: 'break-all',
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {createdSecret}
                    </pre>
                    <div className="Modal-Controls" style={{ marginTop: 16 }}>
                        <Button
                            label={translations.copy}
                            onClick={() =>
                                navigator.clipboard &&
                                navigator.clipboard.writeText(createdSecret)
                            }
                        />
                        <Button
                            label={translations.close}
                            onClick={() => {
                                setCreatedSecret(null);
                                history.push(Paths.WEBHOOKS);
                            }}
                            style={{ marginLeft: '20px' }}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default observer(NewWebhook);
